export default __webpack_public_path__ + "static/media/potencial.65bcd8d7.jpg";